<template>
<div>
  <div v-if="current">
  <heading>Role</heading>
  <job-row-card class="hoverable" :job="job" @click="onJobClicked"/>
  <divider />
  <heading>Applicant</heading>
  <user-row-card class="hoverable" :user="user" @click="onUserClicked(current.userId)" />
  <div v-if="referrer">
    <divider />
    <heading>Referrer</heading>
    <user-row-card class="hoverable" :user="referrer" @click="onUserClicked(current.referrerId)" />
  </div>
  <div v-if="submittedBy">
    <divider />
    <heading>Submitted By</heading>
    <user-row-card class="hoverable" :user="submittedBy" @click="onUserClicked(current.userId)" />
  </div>
  <divider />
  <div v-if="current.applicantResume">
    <heading>CV</heading>
    <resume-field-readonly :value="resume" :link="current.applicantResume" :isFullWidth="true"/>
    <divider />
  </div>
  <div v-if="current.coverLetter ">
    <heading>Cover Letter</heading>
    <text-view class="text-view">
      {{ current.coverLetter }}
    </text-view>
  <divider />
  </div>
  <heading>Status</heading>
  <p>{{ current.status | capitalize }} • Last updated {{ current.updatedAt | formatDate }} </p>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import UserRowCard from '@/components/general/user-row-card'
import JobRowCard from '@/components/jobs/job-row-card'
import Heading from '@/components/general/heading'
import Divider from '@/components/general/divider'
import TextView from '@/components/general/text-view'
import ResumeFieldReadonly from '@/components/jobseekers/resume-field-readonly'
import _ from 'lodash'
import moment from 'moment'
import Users from '@/api/users'

export default {
  components: {
    UserRowCard, JobRowCard, Heading, Divider, TextView, ResumeFieldReadonly
  },
  data () {
    return {
      submittedBy: null
    }
  },
  computed: {
    ...mapState('adminApplications', [
      'current',
      'currentReferral'
    ]),
    resume: {
      get () {
        let cvName = `${this.current.applicantFirstName}-${this.current.applicantLastName}`
        if (this.current.applicantResume && this.current.applicantResume.length > 0) {
          return cvName + '.' + this.current.applicantResume.split('.').pop()
        }
      }
    },
    job () {
      return {
        title: this.current.jobTitle,
        salary: this.current.jobSalary,
        companyName: this.current.jobCompany,
        locations: this.current.jobLocations,
        companyImageUrl: this.current.jobCompanyImageUrl,
        contract: this.current.jobContract,
        location: this.current.jobLocations,
        salaryMin: this.current.jobSalaryMin,
        salaryMax: this.current.jobSalaryMax
      }
    },
    user () {
      return {
        id: this.current.userId,
        firstName: this.current.applicantFirstName || 'Applicant',
        lastName: this.current.applicantLastName || '',
        profilePictureUrl: this.current.applicantProfilePictureUrl,
        location: this.current.applicantLocation || '',
        companyName: this.current.applicantCompanyName || '',
        role: this.current.applicantRole || 'Not Set'
      }
    },
    referrer () {
      if (this.current.referrerId) {
        return {
          id: this.current.referrerId,
          firstName: this.current.referrerFirstName,
          lastName: this.current.referrerLastName,
          profilePictureUrl: this.current.referrerProfilePictureUrl,
          location: this.current.referrerLocation,
          companyName: this.current.referrerCompanyName,
          role: this.current.referrerRole
        }
      }
      return null
    }
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    },
    formatDate (value) {
      return moment(value).format('DD MMM YY')
    }
  },
  methods: {
    async sumittedBy () {
      if (!this.current) return
      if (this.current.registrarId) {
        try {
          const u = await Users.getByAccountId(this.current.registrarId)
          if (u) {
            u.location = u.locationTitle
            this.submittedBy = u
          }
        } catch (err) {
          //
        }
      }
    },
    onJobClicked () {
      const jobId = this.current.jobId
      window.open(`/jobs/${jobId}`, '_blank')
    },
    onUserClicked (userId) {
      window.open(`/jobseekers/${userId}`, '_blank')
    }
  },
  watch: {
    current: {
      deep: true,
      handler: async function (newVal) {
        if (newVal) {
          await this.sumittedBy()
        }
      }
    }
  },
  async mounted () {
    await this.sumittedBy()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.hoverable:hover {
  cursor: pointer;
  background-color: $hover-background;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/applications/application-form.vue